module.exports = __webpack_public_path__ + "img/test_a.8f77ae4b.png";